import React from "react";
import { Select } from "antd";
import type { SelectProps } from "antd";

type AppSelectProps = SelectProps<string>;

const AppSelect: React.FC<AppSelectProps> = (props) => {
  return <Select<string> {...props} />;
};

export default AppSelect;
